import { z } from "zod";

export const matheZahlenraumSchema = z.enum(["0-10", "0-20", "20-50", "20-100", "100-200", "100-1000", "1000-100000"]);
export const matheOperationSchema = z.enum(["addition", "subtraction", "multiplication", "division"]);

export type MatheZahlenraum = z.infer<typeof matheZahlenraumSchema>;
export type MatheOperation = z.infer<typeof matheOperationSchema>;
